<template>
	<MainLayout>
		<div class="container">
            <b-row>
                <b-col lg="5" md="8" sm="10" class="mx-auto">
                    <b-card>
                        <div class="w-100">
                            <img class="img-fluid mb-4" src="../../../assets/ShuttleCentral-ilus1.png">
                        </div>

                        <div v-if="emailVerified === 'unverified_email' && !confirmed" class="text-center">
                            <h3 class="mb-3">{{$t('verifyEmail.title')}}</h3>
                            <p class="text-muted mb-3" v-html="$t('verifyEmail.body', {user: user.firstName})"></p>
                            <b-button variant="info" class="mx-auto mt-1 mb-2" @click="confirmEmail">{{$t('verifyEmail.clickToConfirm')}}</b-button>
                        </div>

                        <div v-if="confirmed" class="text-center">
                            <h3 class="mb-3">{{$t('verifyEmail.confirmedTitle')}}</h3>
                            <p class="text-muted mb-3" v-html="$t('verifyEmail.confirmedBody')"></p>
                            <b-link class="mx-auto mt-1 mb-2 btn btn-primary" href="/">{{$t('verifyEmail.goBack')}}</b-link>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout.vue";

export default {
	components: {MainLayout},
	data() {
		return {
			emailVerified: '',
            token: null,
            confirmed: false,
		};
	},
    methods: {
        confirmEmail() {
            this.$root.api.post(`/users/confirm-email`, {token: this.token}).then((res) => {
                if(res.data.success) {
                    this.confirmed = true

                    let me = this.$root.store.state.currentUser
                    me.emailValidationStatus = 'verified_email'
                    this.$root.store.setUserData(me)
                }
            }).catch(err => {
                this.$root.handleRequestError(err)
            });
        }
    },
	computed: {
        user() {
			if(this.$root.store.state.currentUser)
				return this.$root.store.state.currentUser;
			else
				return ''
		},
    },
	beforeCreate() {
		if (Object.entries(this.$route.query).length !== 0 && this.$route.query.token) {
			let token = typeof this.$route.query.token !== 'string' ? null : this.$route.query.token

			if (token !== null) {
                this.$root.api.post(`/users/validate-email-verification`).then((res) => {
                    this.emailVerified = res.data
                    this.token = token

                    if(res.data === 'does_not_need_verification' || res.data === 'verified_email') {
                        this.$router.push('/')
                    }
                }).catch(err => {
                    this.$root.handleRequestError(err)
                });
			}
		} else {
            this.$router.push('/')
		}
	}
};
</script>
